<template>
  <div class="interview-duration" ref="interviewDuration" :class="showHighlight && 'is-highlight'">
    <span class="label">{{ $t(`${i18nPrefix}.label.interviewDuration`) }}</span>
    <InterviewSelect
      v-model="durationData.hour"
      class="hour-select"
      :selectOptions="hourSuggestions"
      :searchOptions="hourSearchOptions"
      :events="hourSelectEvents"
    />
    <InterviewSelect
      v-model="durationData.minute"
      class="minute-select"
      :selectOptions="minuteSuggestions"
      :searchOptions="minuteSearchOptions"
      :events="minuteSelectEvents"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import InterviewSelect from '@/components/interview/mobile/interviewSelect.vue'

export default {
  components: { InterviewSelect },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.applicantList',
      durationData: {
        hour: null,
        minute: null
      },
      hourInputFocus: false,
      minuteInputFocus: false,
      showHighlight: false
    }
  },
  computed: {
    hourSelectEvents () {
      return {
        formatterValue: (value) => {
          let hour = parseInt(value)
          if (_.isNaN(hour)) {
            hour = 0
          }
          return this.$t(`${this.i18nPrefix}.label.hours`, { hour: hour })
        }
      }
    },
    minuteSelectEvents () {
      return {
        formatterValue: (value) => {
          let minute = parseInt(value)
          if (_.isNaN(minute)) {
            minute = 0
          }
          return this.$t(`${this.i18nPrefix}.label.minutes`, { minute: minute })
        }
      }
    },
    hourSuggestions () {
      return _.chain(0).range(4).map((hour) => {
        return {
          label: this.$t(`${this.i18nPrefix}.label.hours`, { hour: hour }),
          value: hour
        }
      }).value()
    },
    minuteSuggestions () {
      return _.chain(0).range(60, 15).map((minute) => {
        return {
          label: this.$t(`${this.i18nPrefix}.label.minutes`, { minute: minute }),
          value: minute
        }
      }).value()
    },
    hourSearchOptions () {
      return _.chain(0).range(24).map((hour) => {
        return {
          label: this.$t(`${this.i18nPrefix}.label.hours`, { hour: hour }),
          value: hour
        }
      }).value()
    },
    minuteSearchOptions () {
      return _.chain(0).range(60).map((minute) => {
        return {
          label: this.$t(`${this.i18nPrefix}.label.minutes`, { minute: minute }),
          value: minute
        }
      }).value()
    }
  },
  created () {
    this.parseValue(this.value)
  },
  mounted () {
  },
  methods: {
    parseValue (value) {
      const newHour = parseInt(value.hour)
      if (_.isNaN(newHour)) {
        this.durationData.hour = null
      } else {
        this.durationData.hour = newHour
      }
      const newMinute = parseInt(value.minute)
      if (_.isNaN(newMinute) || newMinute >= 60) {
        this.durationData.minute = null
      } else {
        this.durationData.minute = newMinute
      }
    },
    formatValue (durationData) {
      let hour = parseInt(durationData.hour)
      let minute = parseInt(durationData.minute)
      if (_.isNaN(hour)) {
        hour = null
      }
      if (_.isNaN(minute)) {
        minute = null
      }
      return {
        hour,
        minute
      }
    },
    scrollToCenterAndHighlight () {
      this.$refs.interviewDuration.scrollIntoView({ block: 'center', behavior: 'smooth' })
      this.showHighlight = true
      setTimeout(() => { this.showHighlight = false }, 3000)
    }
  },
  watch: {
    durationData: {
      deep: true,
      handler (value) {
        const formatValue = this.formatValue(value)
        this.$emit('change', {
          hour: formatValue.hour,
          minute: formatValue.minute
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.interview-duration {
  display: flex;
  align-items: center;

  .label {
    font-size: 14px;
    color: #000;
    width: 96px;
  }

  .hour-select {
    flex: 1;
  }

  .minute-select {
    margin-left: 10px;
    flex: 1;
  }

  &.is-highlight {
    .hour-select, .minute-select {
      ::v-deep {
        .field-select {
          box-shadow: 0 0 4px 0 rgba(0,150,204,0.3);
          border-radius: 2px;
          border: 1px solid #0096CC;
        }
      }
    }
  }
}
</style>
